import { DEADLINE_ERROR_CODES } from '@prospero/shared';
import { getHttpErrorBody, getHttpErrorStatus, resolveApiErrorMessage } from './error.utils';

const KNOWN_DEADLINE_ERROR_CODES: readonly string[] = Object.values(DEADLINE_ERROR_CODES);

type Translate = (key: string, options?: { defaultValue?: string }) => string;

/** Il server manda un `code` stabile nei 4xx di dominio: si discrimina su quello, mai sul testo. */
export function getDeadlineErrorCode(error: unknown): string | undefined {
  const body = getHttpErrorBody(error);
  if (typeof body !== 'object' || body === null || !('code' in body)) {
    return undefined;
  }
  const { code } = body;
  return typeof code === 'string' && KNOWN_DEADLINE_ERROR_CODES.includes(code) ? code : undefined;
}

/**
 * Messaggio per un errore di scrittura sulle scadenze. I codici di dominio hanno un testo
 * che dice cosa fare (`documents:deadlines.errors.<CODE>`); gli altri errori mostrano il
 * messaggio del server.
 */
export function resolveDeadlineErrorMessage(error: unknown, t: Translate): string {
  const code = getDeadlineErrorCode(error);
  return code ? t(`documents:deadlines.errors.${code}`) : resolveApiErrorMessage(error, t);
}

/** Come sopra, con i due errori propri della presa in carico: data fuori finestra (400) e riga non più applicabile (409). */
export function resolveTakeOverErrorMessage(error: unknown, t: Translate): string {
  if (getDeadlineErrorCode(error)) {
    return resolveDeadlineErrorMessage(error, t);
  }
  switch (getHttpErrorStatus(error)) {
    case 400:
      return t('documents:deadlines.takeOver.errors.invalidDate');
    case 409:
      return t('documents:deadlines.takeOver.errors.notApplicable');
    default:
      return t('documents:deadlines.takeOver.error');
  }
}
